<template>
  <v-container>
    <v-dialog
        class="blue"
        v-model="dialog"
        width="600"
        >
        <div style="height:450px;background:white">
    <!--
        <v-card>
            <v-card-title
            class="headline grey lighten-2 opensansregular"
            primary-title
            >
            Choose indicator
            </v-card-title>

            <v-card-text>
    -->
            <h3 class="blue pa-3 white--text">Choose indicator</h3>
              <treeselect
                :options="items"
                :disable-branch-nodes=true
                class="opensansregularcase size11"
                :placeholder="searchString"
                :label="searchString"
                :search-nested=false
                :flatten-search-results=false
                :limit="1"
                :always-open="true"
                :disable-fuzzy-matching=true
                :searchable=true
                v-model="select" 
                :max-height="360"
                :multiple=false
                 />
              <!--
              <v-treeview
                  :items="items"
                  activatable
                  hoverable
                  open-on-click
                  selected-color="green"
                  color="purple"
                  shaped
                  rounded
                  class="opensansregular size12"
                  @update:active="update"    
              ></v-treeview>
              -->
    <!--
            </v-card-text>
        </v-card>
    -->
        </div>
      </v-dialog>
  </v-container>
</template>

<script>

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    icons: {
      iconfont: 'mdi', // default - only for display purposes
    },
    components: {Treeselect},
    name: 'IndicatorSelector',
    props: {show: Boolean},
    computed: {
      filter () {
        return this.caseSensitive
          ? (item, search, textKey) => item[textKey].indexOf(search) > -1
          : undefined
      }
    },
    watch: {
      select: function (m) {
        console.log(m)
        this.confirmIndicator(m)
      },
      show: function () {
        this.composeTree()
        this.dialog = true
      },
      treev: function () {
      },
      '$store.getters.indicatorsFUA': function() {
        this.composeTreeFUA()
      },
      '$store.getters.indicatorsEFUA': function() {
        this.composeTreeEFUA()
      },
      '$store.getters.indicatorsCY': function() {
        this.composeTreeCY()
      },
      '$store.getters.indicators': function() {
        this.composeTreeRegions()
      }
    },
    methods: {
      showIndicator: function () {
        this.overlay = true
      },
      confirmIndicator: function (indicator) {

        // indicator.redirectUrl

        let params = this.$route.params
        console.log(params)
        let prefix = 'REG'
        if (params.tl !== 'TL2' && params.tl!== 'TL3') {
          prefix = params.tl
        }

        console.log(this.indicatorsForCode)
        console.log(this.indicatorsForCode[prefix + '-' + indicator])
        console.log(prefix + '-' + indicator)
        console.log(this.indicatorsForCode)
        let indiPar = this.indicatorsForCode[prefix + '-' + indicator]
        if (indiPar.redirectUrl) {
          this.dialog = false
          this.$router.replace(indiPar.redirectUrl)
          // location.href = indiPar.redirectUrl
          return
        }

        let indicatorAttr = this.indicatorsForCode[prefix + '-' + indicator]
        console.log(indicatorAttr)
        params.indicod = indicator
        this.$router.replace({ name: this.$router.currentRoute.name, params: params , query: { "showzero": indicatorAttr.ShowZero } })
        this.dialog = false
      },
      update:function(data){
        this.confirmIndicator(this.index_tree[data[0]].indicod)
        // this.$emit("changeIndicator")
        },

      composeTreeCY: function () {
        this.composeTreeGeneral(this.$store.getters.indicatorsCY, 'CY')
      },
      composeTreeFUA: function () {
        this.composeTreeGeneral(this.$store.getters.indicatorsFUA, 'FUA')
      },
      composeTreeEFUA: function () {
        this.composeTreeGeneral(this.$store.getters.indicatorsEFUA, 'EFUA')
      },
      composeTreeGeneral: function (indicatorsData,prefix) {
        let indicators = indicatorsData
        console.log(indicators)
        let self = this
        let ar = []
        this.index_tree = {}
        let i = 1
        for (let m in indicators) {
          let ob = {}        
          ob.id = i++
          ob.name = m
          ob.label = m
          let ar2 = []
          let ar3 = []
          let defaults = [] 
          // let j = 1
          // let isDefault = false
          for (let m2 in indicators[m]) {
              // console.log(m2)
              let ob2 = {}
              ob2.id = i++
              ob2.name = m2
              ob2.label = m2
              ar3 = []
              // let y = 1
              for (let m3 of indicators[m][m2]) {
                  // console.log('>>' + m3)
                  let ob3 = {}
                  ob3.id = i++
                  ob3.name = m3.Theme
                  ob3.label = m3.Theme
                  ob3.url = ''
                  if (m3.url) {
                    ob3.url = m3.url
                  } 

                  ob3.code = m3.Code
                  ob3.unit = m3.Unit
                  ob3.dataset =  m3.Dataset
                  ob3.measure = m3.Measure
                  ob3.indicod = m3.Dataset + '-' + m3.Code + '-' + m3.Measure  

                  ob3.dataset =  prefix
                  ob3.var = m3.Var
                  ob3.indicod = m3.Var
                  ob3.id = ob3.indicod
                  
                  ob3.id = ob3.indicod
                  ob3.redirectUrl = null
                  if (m3.redirectUrl) {
                    ob3.redirectUrl = m3.redirectUrl
                  }

                  if (m3.disabledT2) {
                    ob3.isDisabled = true
                  }
                  this.indicatorsForCode[prefix + '-' + ob3.indicod] = m3
                  this.index_tree[i-1] = ob3
                  if (m2 === 'default') {
                    defaults.push(ob3)
                  } else {
                    ar3.push(ob3)
                  }
              }
              if (m2 !== 'default') {
                ob2.children = ar3
                ar2.push(ob2)
              }
          }
          // console.log(ar2)
          // console.log(defaults)
          let lenDefaults = defaults.length
          if (lenDefaults > 0) {
            for (let d = lenDefaults - 1 ; d >= 0; d--) {
              ar2.unshift(defaults[d])
            }
          }
          ob.children = ar2
          ar.push(ob) 
        }
        console.log(ar)
        console.log(self.index_tree)

        self.items = ar
        this.$store.commit('setIndicatorsForCode', this.indicatorsForCode)
      },

      composeTreeRegions: function () {
        let indicators = this.$store.getters.indicators
        console.log(indicators)
        let self = this
        let ar = []
        this.index_tree = {}
        let i = 1
        for (let m in indicators) {
          let ob = {}        
          ob.id = i++
          ob.name = m
          ob.label = m
          let ar2 = []
          let ar3 = []
          let defaults = [] 
          // let j = 1
          // let isDefault = false
          for (let m2 in indicators[m]) {
              // console.log(m2)
              let ob2 = {}
              ob2.id = i++
              ob2.name = m2
              ob2.label = m2
              ar3 = []
              // let y = 1
              for (let m3 of indicators[m][m2]) {
                  // console.log('>>' + m3)
                  let ob3 = {}
                  ob3.id = i++
                  ob3.name = m3.Theme
                  ob3.label = m3.Theme
                  ob3.url = ''
                  if (m3.url) {
                    ob3.url = m3.url
                  } 
                  ob3.code = m3.Code
                  ob3.unit = m3.Unit
                  ob3.dataset =  m3.Dataset
                  ob3.measure = m3.Measure
                  ob3.indicod = m3.Dataset + '-' + m3.Code + '-' + m3.Measure                
                  ob3.id = ob3.indicod
                  ob3.redirectUrl = null
                  if (m3.redirectUrl) {
                    ob3.redirectUrl = m3.redirectUrl
                  }

                  if (m3.disabledT2) {
                    ob3.isDisabled = true
                  }
                  this.indicatorsForCode['REG-' + ob3.indicod] = m3
                  this.index_tree[i-1] = ob3
                  if (m2 === 'default') {
                    defaults.push(ob3)
                  } else {
                    ar3.push(ob3)
                  }
              }
              /*
              if (m2 === 'default') {
                //console.log(ar3)
                isDefault = true
                break
                // ob2.children = ar3
                // ar2.push(ar3)
              } else {
                ob2.children = ar3
                ar2.push(ob2)
              }
              */
              if (m2 !== 'default') {
                ob2.children = ar3
                ar2.push(ob2)
              }
          }
          // console.log(ar2)
          // console.log(defaults)
          let lenDefaults = defaults.length
          if (lenDefaults > 0) {
            for (let d = lenDefaults - 1 ; d >= 0; d--) {
              ar2.unshift(defaults[d])
            }
          }
          /*
          for (let d of defaults) {
            // ar2.push(d)
            ar2.unshift(d)
          }
          */
          /*
          if (isDefault) {
            ob.children = ar3
          } else {
          */
            ob.children = ar2
          /*
          }
          */
          ar.push(ob) 
        }
        console.log(ar)
        console.log(self.index_tree)

        self.items = ar
        this.$store.commit('setIndicatorsForCode', this.indicatorsForCode)
      },



      composeTree: function() {
        // let indicators = this.$store.getters.indicators
        let TL = this.$store.getters.TL
        //console.log(TL)
        if (TL === 'TL2' || TL === 'TL3') {
          this.composeTreeRegions()
        }
        if (TL === 'FUA') {
          this.composeTreeFUA()
        }
        if (TL === 'EFUA') {
          this.composeTreeEFUA()
        }
        if (TL === 'CY') {
          this.composeTreeCY()
        }
      }
    },
    mounted () {
      // console.log(indicators)
      //console.log("INDICATORSELECTOR mounted")
      //console.log(self.items)
      this.dialog = this.show
      //this.$emit("changeIndicator")
    },
    data: () => ({
        items: [],
        treev: 1,
        dialog: false,
        index_tree: {},
        indicatorsForCode: {},
        select: null,
        searchString: ''
        //active: 1
    })
    
}
</script>
<style scoped>

</style>
